import React, { Fragment } from 'react';
import { useSearch } from '../../contexts/SearchContext';
import Highlighter from "react-highlight-words";

interface HighlightedTextProps {
  text: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text }) => {
  const { searchTerm } = useSearch();

  const lines = text.split(/\r?\n|<br\s*\/?>/i);
  return (
    <>
      {lines.map((line, index) => (
        <Fragment key={index}>
          <Highlighter
            highlightClassName="highlight"
            highlightStyle={{ backgroundColor: '#dfc21e', fontWeight: 'bold' }}
            searchWords={[searchTerm]}
            autoEscape={true}
            textToHighlight={line}
          />
          {index < lines.length - 1 && <br />}
        </Fragment>
      ))}
    </>
  );
};

export default HighlightedText;